import { useQuery } from 'react-query';
import { GetItemByIdParams, getItemByItemId } from '../clients/itemService';
import { RoutingUIError } from '../components/ErrorBoundary/RoutingUIError';
import { Item } from '../types';

type UseGetItemByItemIdProps = GetItemByIdParams & {
  enabled?: boolean;
  onSuccess?: (data: Item) => void;
  onError?: (error: RoutingUIError | Error) => void;
};

export const useGetItemByItemId = (props: UseGetItemByItemIdProps) => {
  const { enabled = true, onSuccess, onError } = props;

  return useQuery<Item, RoutingUIError | Error>(['itemService', props.itemLink], () => getItemByItemId(props), {
    enabled,
    onSuccess,
    onError,
  });
};
